// extracted by mini-css-extract-plugin
export default {"Container":"skeleton_Container__wM3DR","wrapper":"skeleton_wrapper__ia9Zr"};